import { Config } from './Config';

export const isAgeSelectorEnabled = () => Config.get('isAgeSelectorEnabled');
